module.exports = __webpack_public_path__ + "static/media/roof-video.b1c21afc.webp";